(() => {
  const node = document.getElementById('wdlt-search-vocabulary');
  if (!node) return;
  const vocabulary = JSON.parse(node.textContent);
  const words = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim().split(/\s+/).filter(Boolean);
  const quote = value => '"' + value.replace(/[\\"]/g, '\\$&') + '"';
  const colors = [['black','blk'],['white','wht'],['grey','gray'],['brown'],['blue'],['green'],['red'],['pink'],['purple'],['orange'],['yellow'],['beige'],['ivory'],['navy'],['olive'],['khaki'],['silver','sil'],['gold'],['cream'],['charcoal'],['coffee'],['camel'],['taupe'],['ecru'],['burgundy'],['multicolour','multicolor','multi']];
  const categories = [
    ['skirt','skirts'],['dress','dresses','gown','gowns'],['pants','pant','trouser','trousers','jogger','joggers','sweatpants'],['jean','jeans'],['short','shorts'],
    ['jacket','jackets','blazer','blazers','coat','coats','parka','parkas','outerwear'],['shirt','shirts'],['tshirt','tshirts','tee','tees'],['top','tops','blouse','blouses','cami','camisole'],
    ['sweater','sweaters','pullover','pullovers','knitwear','cardigan','cardigans'],['hoodie','hoodies','sweatshirt','sweatshirts'],['vest','vests'],['jumpsuit','jumpsuits','overall','overalls'],
    ['shoe','shoes','footwear','sneaker','sneakers','boot','boots','sandal','sandals','mule','mules','loafer','loafers','derby','derbies','slide','slides','flat','flats','flipflop'],
    ['hat','hats','cap','caps','beanie','beanies','headwear','fedora','fedoras'],['bag','bags','handbag','handbags','backpack','backpacks','pouch','pouches'],
    ['earring','earrings','earcuff','earcuffs','hoop','hoops'],['ring','rings'],['necklace','necklaces'],['bracelet','bracelets'],['sock','socks'],['scarf','scarves'],['belt','belts'],['tie','ties'],['sunglasses','eyewear','glasses'],['mug','mugs'],['tumbler','tumblers'],['vase','vases'],['candle','candles']
  ];
  const brands = (vocabulary.vendors || []).map(vendor => ({tokens:words(vendor), clause:'vendor:' + quote(vendor)}));
  const alias = (name, vendors) => {if(vendors.length)brands.unshift({tokens:words(name),clause:'('+vendors.map(v=>'vendor:'+quote(v)).join(' OR ')+')'});};
  alias('Sftm',vocabulary.vendors.filter(v=>words(v).join(' ')==='song for the mute'));
  alias('Issey Miyake',vocabulary.vendors.filter(v=>words(v).join(' ').includes('issey miyake')));
  brands.push({tokens:['adidas'],clause:'title:adidas*'});
  brands.sort((a,b)=>b.tokens.length-a.tokens.length);
  const categoryTerms = token => {
    const group=categories.find(group=>group.includes(token));
    if(!group)return null;
    if(['jacket','jackets','blazer','blazers','coat','coats','parka','parkas'].includes(token))return [token.replace(/s$/,'')];
    if(['sneaker','sneakers','boot','boots','sandal','sandals','mule','mules','loafer','loafers','derby','derbies','slide','slides','flat','flats'].includes(token))return [token==='derbies'?'derby':token.replace(/s$/,'')];
    return group;
  };
  function query(value) {
    const raw=value.trim();
    if(!raw || /\b(?:title|vendor|tag|product_type|body|variants\.[a-z]+):/i.test(raw))return raw;
    const tokens=words(raw.replace(/t[ -]shirts?/gi,'tshirt').replace(/flip[ -]flops?/gi,'flipflop'));
    const used=new Set(),clauses=[];
    for(let i=0;i<tokens.length;i++){
      if(used.has(i))continue;
      const brand=brands.find(b=>b.tokens.every((word,j)=>tokens[i+j]===word&&!used.has(i+j)));
      if(brand){clauses.push(brand.clause);brand.tokens.forEach((_,j)=>used.add(i+j));}
    }
    tokens.forEach((token,i)=>{
      if(used.has(i))return;
      // Resolve partial brand names against the store's real vendor vocabulary.
      // Exact vendor clauses are more reliable than vendor:prefix* in Shopify search.
      const vendorMatches=(vocabulary.vendors||[]).filter(vendor=>words(vendor).some(word=>word.startsWith(token)));
      if(vendorMatches.length && token.length>=2){
        const exactVendors=vendorMatches.slice(0,30).map(vendor=>'vendor:'+quote(vendor));
        clauses.push('('+[...exactVendors,'title:'+token+'*'].join(' OR ')+')');
        return;
      }
      const color=colors.find(group=>group.includes(token));
      if(color){
        const otherColors=colors.filter(group=>group!==color&&!group.includes('multi')).flat();
        const fallback='('+color.map(term=>'tag:'+quote(term)).join(' OR ')+') AND '+otherColors.map(term=>'-title:'+quote(term)).join(' AND ');
        clauses.push('('+[...color.flatMap(term=>['title:'+quote(term),'variants.title:'+quote(term)]),'('+fallback+')'].join(' OR ')+')');return;
      }
      const terms=categoryTerms(token);
      if(terms){
        const types=(vocabulary.types||[]).filter(type=>words(type).some(word=>terms.some(term=>word===term||word===term+'s')));
        clauses.push('('+[...types.map(type=>'product_type:'+quote(type)),...[...new Set(terms.map(term=>term.replace(/s$/,'')))].map(term=>'title:'+term+'*')].join(' OR ')+')');return;
      }
      clauses.push('('+['title','vendor','tag','product_type','variants.sku'].map(field=>field+':'+token+'*').join(' OR ')+')');
    });
    return [...new Set(clauses)].join(' AND ');
  }
  const urlFor = (raw, base) => {
    const url=new URL(base || vocabulary.searchUrl,location.origin);
    url.searchParams.set('q',query(raw));url.searchParams.set('wdlt_q',raw.trim());url.searchParams.set('type','product');
    url.searchParams.delete('options[prefix]');
    return url;
  };
  window.wdltStrictSearch={query,urlFor};
  const current=new URL(location.href),raw=current.searchParams.get('wdlt_q')||current.searchParams.get('q')||'';
  if(document.getElementById('Search-In-Template')&&raw){
    const precise=urlFor(raw,current);
    if(precise.searchParams.get('q')!==current.searchParams.get('q')){
      window.wdltSearchRedirecting=true;location.replace(precise);return;
    }
    document.getElementById('Search-In-Template').value=raw;
    document.querySelectorAll('.cs_sort li[data-value] a').forEach(link=>{
      const sorted=new URL(current);
      sorted.searchParams.set('sort_by',link.closest('li').dataset.value==='best-selling'?'relevance':link.closest('li').dataset.value);
      sorted.searchParams.delete('page');
      link.href=sorted.href;
    });
    const actual=current.searchParams.get('q');
    document.querySelectorAll('.template-search a[href]').forEach(link=>{
      const target=new URL(link.href,location.origin);
      if(target.pathname===current.pathname&&target.searchParams.get('q')===actual){target.searchParams.set('wdlt_q',raw);link.href=target.href;}
    });
    if(actual!==raw){
      document.title=document.title.split(actual).join(raw);
      document.querySelectorAll('.template-search [role="status"],.template-search .title--primary').forEach(el=>{
        const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);
        while(walker.nextNode())walker.currentNode.textContent=walker.currentNode.textContent.split(actual).join(raw);
      });
    }
  }
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!form.matches('form.search'))return;
    const input=form.querySelector('input[name="q"]');
    if(!input?.value.trim()||form.querySelector('[aria-selected="true"] a'))return;
    event.preventDefault();
    const url=new URL(form.action,location.origin);
    for(const [key,value] of new FormData(form))if(key!=='q'&&value)url.searchParams.set(key,value);
    location.assign(urlFor(input.value,url));
  },true);
})();
